// import React from "react";
// import { DollarSign, Calendar, MapPin, Briefcase, CreditCard } from "lucide-react";
// import "./NttCard.css";
// import Tooltip from "@mui/material/Tooltip";

// const formatNumber = (num = 0) => {
//   if (num >= 1_000_000) {
//     return (num / 1_000_000).toFixed(2).replace(/\.?0+$/, "") + "M";
//   } else if (num >= 1_000) {
//     return (num / 1_000).toFixed(2).replace(/\.?0+$/, "") + "K";
//   }
//   return num?.toFixed?.(2) || num;
// };

// const NttCard = ({ sowdashboard, onCardClick }) => {

//   const cards = [
//     { 
//       title: "Total Amount", 
//       value: `₹ ${formatNumber(sowdashboard?.total_amount || 0)}`,
//       icon: <DollarSign size={24} color="#4CAF50" />,
//       clickable: false
//     },
//     { 
//       title: "Total Annual Amount", 
//       value: `₹ ${formatNumber(sowdashboard?.total_annual_amount || 0)}`,
//       icon: <Calendar size={24} color="#2196F3" />,
//       clickable: false
//     },
//     { 
//       title: "Locations", 
//       value: parseInt(sowdashboard?.locations_count || 0, 10),
//       icon: <MapPin size={24} color="#FF9800" />,
//       clickable: true,
//       type: "locations"
//     },
//     { 
//       title: "Services", 
//       value: parseInt(sowdashboard?.services_count || 0, 10),
//       icon: <Briefcase size={24} color="#9C27B0" />,
//       clickable: true,
//       type: "services"
//     },
//     { 
//       title: "Total Setup Charge", 
//       value: `₹ ${formatNumber(sowdashboard?.total_setup_charge || 0)}`,
//       icon: <CreditCard size={24} color="#FF5722" />,
//       clickable: false
//     },
//     { 
//       title: "Monthly Charge", 
//       value: `₹ ${formatNumber(sowdashboard?.total_monthly_charge || 0)}`,
//       icon: <CreditCard size={24} color="#3F51B5" />,
//       clickable: false
//     },
//   ];

//   return (
//     <div className="sixcards-container">
//       {cards.map((card, index) => (
//         <div 
//           key={index}
//           className={`sixcards-card ${card.clickable ? 'clickable' : ''}`}
//           onClick={() => card.clickable && onCardClick(card.type)}
//           style={{ cursor: card.clickable ? "pointer" : "default" }}
//         >
//           <div className="sixcards-card-content">
//             <div className="sixcards-card-text">
//               <p className="sixcards-card-title">{card.title}</p>
//               <p className="sixcards-card-value">{card.value}</p>
//             </div>
//             <div className="sixcards-card-icon">{card.icon}</div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default NttCard;
// NttCard.jsx
import React from "react";
import { DollarSign, Calendar, MapPin, Briefcase, CreditCard } from "lucide-react";
import Tooltip from "@mui/material/Tooltip";
import "./NttCard.css";

// Compact number formatter
const formatNumber = (num = 0) => {
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(2).replace(/\.?0+$/, "") + "M";
  } else if (num >= 1_000) {
    return (num / 1_000).toFixed(2).replace(/\.?0+$/, "") + "K";
  }
  return num?.toFixed?.(2) || num;
};

const NttCard = ({ sowdashboard, onCardClick }) => {
  const cards = [
    { 
      title: "Total Amount", 
      value: `${formatNumber(sowdashboard?.total_amount || 0)}`,
      tooltip: "The combined total of all monthly charges and setup charges.",
      icon: <DollarSign size={24} color="#4CAF50" />,
      clickable: false
    },
    { 
      title: "Total Annual Amount", 
      value: `${formatNumber(sowdashboard?.total_annual_amount || 0)}`,
      tooltip: "The total annual value calculated across all SOWs.",
      icon: <Calendar size={24} color="#2196F3" />,
      clickable: false
    },
    // { 
    //   title: "Services", 
    //   value: parseInt(sowdashboard?.services_count || 0, 10),
    //   icon: <Briefcase size={24} color="#9C27B0" />,
    //   clickable: true,
    //   type: "services"
    // },
    { 
      title: "Total Setup Charge", 
      value: `${formatNumber(sowdashboard?.total_setup_charge || 0)}`,
      tooltip: "The sum of all setup charges from every SOW.",
      icon: <CreditCard size={24} color="#FF5722" />,
      clickable: false
    },
    { 
      title: "Monthly Charge", 
      value: `${formatNumber(sowdashboard?.total_monthly_charge || 0)}`,
      tooltip: "The total of all monthly recurring charges across all SOWs.",
      icon: <CreditCard size={24} color="#3F51B5" />,
      clickable: false
    },
        { 
      title: "Locations", 
      value: parseInt(sowdashboard?.locations_count || 0, 10),
      icon: <MapPin size={24} color="#FF9800" />,
      clickable: true,
      type: "locations"
    },
  ];

  return (
    <div className="sixcards-container">
      {cards.map((card, index) => {
        const cardElement = (
          <div 
            className={`sixcards-card ${card.clickable ? "clickable" : ""}`}
            onClick={() => card.clickable && onCardClick(card?.type)}
            style={{ cursor: card.clickable ? "pointer" : "default" }}
          >
            <div className="sixcards-card-content">
              <div className="sixcards-card-text">
                <p className="sixcards-card-title">{card.title}</p>
                <p className="sixcards-card-value">{card.value}</p>
              </div>
              <div className="sixcards-card-icon">{card.icon}</div>
            </div>
          </div>
        );

        return card.tooltip ? (
          <Tooltip title={card.tooltip} arrow placement="top" key={index}>
            {cardElement}
          </Tooltip>
        ) : (
          <div key={index}>{cardElement}</div>
        );
      })}
    </div>
  );
};

export default NttCard;
